var $95e3a6a5b5170df3$exports = {};
$95e3a6a5b5170df3$exports = {
    "endTime": `Heure de fin`,
    "startTime": `Heure de d\xe9but`,
    "time": `Heure`
};


export {$95e3a6a5b5170df3$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
